import {Component, OnInit} from '@angular/core';
import {NavBarService} from '../../../services/nav-bar/nav-bar.service';
import {AreaService} from '../../../services/area/area.service';
import {TranslatableString} from '../../../models/TranslatableString';
import {BaseHttpService} from '../../../services/base-http/base-http.service';
import {OffersService} from '../../../services/offers/offers.service';

@Component({
  selector: 'app-area-filter',
  templateUrl: './area-filter.component.html',
  styleUrls: ['./area-filter.component.scss']
})
export class AreaFilterComponent implements OnInit {
  language: string;
  areasListnew: {
    name: TranslatableString;
    id: string;
    offers: number;
    isSelected: boolean;
  }[] = [];
  areasList: {
    name: string;
    id: string;
    offers: number;
    isSelected: boolean;
  }[];
  areasNames: TranslatableString[] = [];
  
  constructor(
    private nav: NavBarService,
    private baseService: BaseHttpService,
    public areaService: AreaService,
    public offerService: OffersService) {
  }
  
  ngOnInit() {
    // this.areasList = this.areaService.areas.filter(areas => areas.offers >= 0);
    // this.offerService.subscribe(regionNames => {
    //   let i = 0;
    //   this.areasList.forEach(area => {
    //     area.name = area.name.split('\'').join('"');
    //     const region = regionNames.find(r => r.name_bg === area.name);
    //     if (region) {
    //       const trRegionName = new TranslatableString(region.name, region.name_en, region.name_bg, region.name_ru);
    //       const ar = {
    //         name: trRegionName,
    //         id: area.id,
    //         offers: area.offers,
    //         isSelected: area.isSelected
    //       };
    //       if (ar !== undefined){
    //         this.areasListnew.push(ar);
    //         this.areasNames.push(trRegionName);
    //       }
    //     }
    //     i++;
    //   });
    // });
    setTimeout(() => {
      this.nav.deselectAll();
      this.nav.homeSelected = true;
    }, 0);
    setTimeout(() => {
      this.getSortedAreasByNames();
      // .forEach(area => {
      //   console.log(this.areaService.getAreaName(area.name));
      // });
    }, 1000);
  }
  
  clickOnArea(id: string) {
    // this.areaService.clickArea(id);
    const area = this.areasList.find(a => a.id === id);
    area.isSelected = !area.isSelected;
  }
  
  getSortedAreasByNames(): { name: string; id: string; offers: number; isSelected: boolean; }[] {
    return this.areasList.sort(this.sortByTranslatedName);
  }
  
  sortByTranslatedName(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }
  
  test(name) {
    return this.areasListnew.find(a => a.name.valueBg === name);
  }
}
